import { InstitutionInfo } from 'modules/institutions/core/type';

export const defaultStation = {
  postalCode: null,
  name: '',
  state: '',
  stationId: '',
  address: '',
  city: '',
  country: '',
  id: '',
};

export const defaultInstitutionInfo: Partial<InstitutionInfo> = {
  name: '',
  code: '',
};
